import React from "react";
import { connect } from "react-redux";
import CommonCard from "./CommonCard"
import AddIcon from "../UIComponents/AddIcon";
import { getKeywordList, deleteKeywordList } from "../Actions/KeywordManagementAPI";
import { confirmAlert } from 'react-confirm-alert';

class KeywordManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        Name: '',
        PageNumber: 1,
        PageSize: 25
      },
    }
    this.handleInputChange = this.handleInputChange.bind(this);
    this.SearchData = this.SearchData.bind(this);
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    dispatch({ type: 'SubBannerTitle', data: "Keyword Management" });
    dispatch(getKeywordList(this.state.searchData));
  }

  handleInputChange(e) {
    this.state.searchData.Name = e.target.value;
    if (e.target.value === "") {
      this.props.dispatch(getKeywordList(this.state.searchData));
    }
    this.setState({});
  }

  SearchData(Pgno) {
    this.state.searchData.PageNumber = Pgno;
    this.props.dispatch(getKeywordList(this.state.searchData));
  }

  DeletePopup(item) {
    confirmAlert({
        message: 'Are you sure want to delete ?',
        buttons: [
            {
                label: 'Yes',
                onClick: () => {
                    this.DeleteKeywordData(item)
                }
            },
            {
                label: 'No',
                onClick: () => { }
            }
        ]
    });
    }
  DeleteKeywordData(item) {
    let listitem = {
      keywordId: item.keywordId,
      keyword: item.keyword,
      isDeleted: true,
      modifiedBy: ""
    }
    this.props.dispatch(deleteKeywordList(listitem));
    this.state.searchData.Name = "";
    this.setState({});
  }

  ClearInput = () => {
    this.state.searchData.Name = "";
    this.props.dispatch(getKeywordList(this.state.searchData));
    this.setState({});
  }

  hideSidePanel = () => {
    this.props.history.goBack();
    this.props.dispatch({ type: "ShowSidePan", data: false });
  }

  render() {
    const { showSidePane, KeywordList } = this.props;
    const { flagList } = this.state;
    return (
      <div className="full-height">
        <button
          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3"
          onClick={() => this.hideSidePanel()}
        >
          &larr; Back
                        </button>
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div className=" card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                      <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                          Keyword Management
                        </h5>
                        <div className="m-1 flex"
                          onClick={() =>
                            this.AddKeyword()
                          }>
                          <span className="card-title m-auto">Add</span>
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row pb-3">
                        <div className={showSidePane ? "col-lg-6 " : "col-lg-6 "}>
                          <label className="form-label">Keyword</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="keyword"
                            placeholder="Keyword"
                            value={this.state.searchData.Name}
                            onChange={e => this.handleInputChange(e)}
                          ></input>
                        </div>

                        <div className={showSidePane ? "col-lg-6" : "col-lg-6"}>
                          <label className="mt-4"></label><br></br>
                          <div
                            className="search-btn-col"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchData(1)}
                            >
                              {" "}
                              Search{" "}
                            </button>

                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              Clear{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {KeywordList ? (
                <CommonCard
                  arraylist={KeywordList.data}
                  pageSize={KeywordList.pagination.pageSize}
                  currentPage={KeywordList.pagination.currentPage}
                  totalRecords={KeywordList.pagination.totalcount ? KeywordList.pagination.totalcount : 0}
                  DeleteKeyword={item => this.DeletePopup(item)}
                  setUpdatedState={(value) => this.SearchData(value)}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }

  ShowSidePanel = (id) => {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(`/Home/Lookup/${this.state.titleName}/Edit/${id}`);
  };

  AddKeyword = () => {
    //  this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(`/Home/Management/AddKeyword`);
  };
}



function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    KeywordList: state.MasterScreenReducer.KeywordList,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KeywordManagement);
